import {Switch} from 'react-router-dom';
import {PropsRoute} from '@core/app/Routes';
import Rankings from './Rankings';

const RankingsIndex = ({user, organization}) => {
  return (
    <Switch>
      <PropsRoute
        exact
        path='/:part(a|s|b|p)/:slug/research/rankings'
        user={user}
        organization={organization}
        component={Rankings}
      />
    </Switch>
  );
};

export default RankingsIndex;
